/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { LoggingSettings } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, LoggerLevel } from '@modules/ui-types'

import { getConstructorLoggingSettings } from '@/reducers/constructorLoggingSettings'
import {
  patchConstructorLoggingSettingsRequest,
  fetchConstructorLoggingSettingsRequest,
} from '@/reducers/asyncRequests/registry'

import ZkLoggingSettingsButton from '../../ZkLoggingSettingsButton'
import {
  fetchConstructorLoggingSettings,
  patchConstructorLoggingSettings,
} from '../../../actions/constructors'

import type { ReduxState } from '@/types/redux'

type PatchLoggingLevels = {
  [key: string]: LoggerLevel | null
}

type StateProps = {
  loggingSettings: LoggingSettings | null
  fetchLoggingSettingsRequest: AsyncRequestState
  patchLoggingSettingsRequest: AsyncRequestState
}

type DispatchProps = {
  fetchLoggingSettings: () => void
  patchLoggingSettings: (settings: { loggingLevels: PatchLoggingLevels }) => Promise<void>
}

type ConsumerProps = {
  regionId: string
  constructorId: string
}

const mapStateToProps = (
  state: ReduxState,
  { regionId, constructorId }: ConsumerProps,
): StateProps => ({
  loggingSettings: getConstructorLoggingSettings(state, regionId, constructorId),
  fetchLoggingSettingsRequest: fetchConstructorLoggingSettingsRequest(
    state,
    regionId,
    constructorId,
  ),
  patchLoggingSettingsRequest: patchConstructorLoggingSettingsRequest(
    state,
    regionId,
    constructorId,
  ),
})

const mapDispatchToProps = (
  dispatch,
  { regionId, constructorId }: ConsumerProps,
): DispatchProps => ({
  fetchLoggingSettings: () =>
    dispatch(fetchConstructorLoggingSettings({ regionId, constructorId })),
  patchLoggingSettings: (settings: { loggingLevels: PatchLoggingLevels }) =>
    dispatch(patchConstructorLoggingSettings({ regionId, constructorId, ...settings })),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ZkLoggingSettingsButton)
